import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center bg-background-50 overflow-hidden"
      style={{ paddingTop: 'calc(var(--header-height) + 2rem)' }}
    >
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
              {heroData.tagline}
            </span>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>
            <p className="text-sm md:text-base text-primary-500 font-medium mb-5">
              {heroData.slogan}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-heading text-accent-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.text}
                <i className="ri-download-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src={heroData.heroImage}
                alt="51吃瓜官网入口导航主视觉 - 娱乐八卦热点聚合平台"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}